module.exports = __webpack_public_path__ + "img/FZLC_3.d543532a.jpg";